import { useEffect, useState } from "react";
import { AnunciosShopkeeper } from "../dto/ShopkeeperDTO";
import { calcularCountdown, getDataLimiteAnuncio } from "../helpers/Helpers";

export function useCountdownAnuncio(anuncio: AnunciosShopkeeper) {
  const dataLimite = getDataLimiteAnuncio(anuncio);

  const [countdown, setCountdown] = useState(() =>
    calcularCountdown(anuncio.current_date, dataLimite)
  );

  useEffect(() => {
    if (countdown.expired) return;

    const interval = setInterval(() => {
      setCountdown((prev) => {
        const next = calcularCountdown(
          new Date(
            new Date(anuncio.current_date).getTime() +
              (Date.now() - new Date(anuncio.current_date).getTime())
          ).toISOString(),
          dataLimite
        );

        if (next.expired) {
          clearInterval(interval);
        }

        return next;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [anuncio, dataLimite, countdown.expired]);

  return countdown;
}
